import DynamicButtonLink from "@shared/components/DynamicButtonLink";
import { ArrowIcon } from "@shared/components/ui/Icon";
import React from "react";

export interface GettingStartedSectionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonTarget?: string;
}

const GettingStartedSection: React.FC<GettingStartedSectionProps> = ({
  title = "",
  description = "",
  buttonText = "",
  buttonLink = "",
  buttonTarget = "_self",
}) => {
  return (
    <div className="bg-gradient-to-br from-blue-800 to-blue-400 shadow-sm rounded-xl overflow-hidden h-full">
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className="font-madefor font-semibold text-white">
          Getting Started
        </h2>
      </header>
      <div className="p-5 text-white rounded-b-xl">
        <div className="h-full flex flex-col items-start">
          <div className="mb-6">
            <h2 className="text-5xl mb-2">{title}</h2>
            <p className="mb-6 text-xl">{description}</p>
          </div>

          <DynamicButtonLink
            buttonText={buttonText}
            buttonLink={buttonLink}
            buttonTarget={buttonTarget}
            variant="outline"
            className="bg-white"
            icon={<ArrowIcon />}
          />
        </div>
      </div>
    </div>
  );
};

export default GettingStartedSection;
